import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["overreaching-and-overtraining"]!;

export function Body() {
  return (
    <>
      <p>
        Hard training should make you tired. That is part of how you get better. But when does
        tiredness become a problem? A joint statement from the European College of Sport
        Science and the American College of Sports Medicine describes the difference.
      </p>

      <h2>Three levels of tiredness</h2>
      <p>
        Short-term overreaching is planned. After a hard period, performance drops for a while,
        and after recovery it improves. The statement calls this functional overreaching.
      </p>
      <p>
        When training and recovery are out of balance for longer, performance can stay down for
        weeks. This is called non-functional overreaching.
      </p>
      <p>
        Overtraining syndrome is the most serious form, a long-lasting failure to adapt. Fatigue,
        falling performance and mood changes are typical. It can be very hard to tell apart from
        non-functional overreaching, and the diagnosis depends on ruling out other causes.
      </p>

      <h2>What else can look like overtraining</h2>
      <p>
        The statement stresses ruling out illness and infection, and factors such as eating too
        little, too little carbohydrate or protein, iron deficiency and allergies. Several of
        these can give the same symptoms.
      </p>

      <h2>What it means for you</h2>
      <p>
        Tiredness after a hard week is normal and passes with a few easier days. Tiredness that
        doesn't pass, runs that keep feeling harder at the same pace, poor sleep and low mood
        together are signs to ease off. If it lasts for weeks, talk to a doctor to rule out
        other causes.
      </p>
      <p>
        It is much easier to prevent than to treat. Easy days, enough sleep and enough food do
        most of the work.
      </p>

      <h2>What the statement can't tell you</h2>
      <p>
        There is no single test for overtraining. The statement reviews hormones, performance
        tests, psychological tests and blood markers, and concludes that none of them is good
        enough to use on its own.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training compares how hard each session felt with what was expected. If several
        sessions in a row feel harder than they should, the next sessions are made easier.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Meeusen et al. (2013), Prevention, diagnosis, and treatment of the overtraining
          syndrome: joint consensus statement of the European College of Sport Science and the
          American College of Sports Medicine.{" "}
          <a href="https://doi.org/10.1249/MSS.0b013e318279a10a">Medicine & Science in Sports & Exercise</a>.
        </li>
      </ul>
    </>
  );
}
